'use client';
import useSWR from "swr";
import { resolverService } from "../resolvers/resolverService";
const useSWRNftBalance = (address, network, contractAddress, { enabled = true } = {}) => {
    const { data: balance, error, isLoading } = useSWR((enabled && network && address && contractAddress) ? `/nft-balance/${address}/${network.name}/${contractAddress}` : null, () => {
        if (!network || !contractAddress || !address)
            return 0;
        return resolverService.getNftResolver().getBalance({ address, network, contractAddress });
    }, { refreshInterval: enabled ? 60000 : 0, keepPreviousData: !enabled });
    return {
        balance: typeof balance === 'number' ? balance : 0,
        isLoading,
        error
    };
};
export default useSWRNftBalance;
